// 非遗定制弹窗  数据对接非遗项目
import { handleHttp, loadScript, locationHandle } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  data() {
    return {
      person: [],
      timer: null,
      linkcontainerflag: false,
      iframeurl: '',
      routeflag: false
    };
  },
  watch: {
    '$attrs.detail'(val) {
      if (val) {
        console.log(val);
      }
    },
    '$attrs.detail.person': {
      handler(val) {
        console.log(`this.person`);
        console.log(val);
        this.person = val;
      },
      deep: true
    },
    '$attrs.detail.introduce'(val) {
      if (val) {
        let that = this;
        /* MultiEditor存在 */
        that.timer = setInterval(() => {
          if (MultiEditor !== undefined) {
            clearInterval(that.timer);
            that.timer = null;
            MultiEditor.init('detail', null, {
              attachMode: 'preview',
              largePreview: 'largePreview'
            });
            MultiEditor.renderRichtext('editor1', val);
          }
        }, 500);
      }
    }
  },
  created() {
    loadScript('https://noteyd.chaoxing.com/res/plugin/ueditor4thirdparty/multieditor.js');
  },
  methods: {
    // 关闭事件
    closePop() {
      this.$emit('closeHandle');
    },
    goLocation(url) {
      let details = {
        placeName: this.$attrs.detail.correlation_address[0].address,
        linkTarget: '否'
      };
      locationHandle.call(this, details, {
        route: this.$attrs.detail.correlation_address
      });
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = '';
    },
    showperson(val) {
      if (val !== '') {
        if (document.body.clientWidth < 768) {
          window.open(val);
        } else {
          this.linkcontainerflag = true;
          this.iframeurl = val;
        }
      }
    }
  }
};